import React from 'react';
import ServiceDetailTemplate from '../components/service/ServiceDetailTemplate';

function Seguros() {
    const data = {
        title: "Seguros",
        // Seguindo a sequência: /assets/images/novos/1/3.png
        mainImage: "/assets/images/novos/1/3.png",
        description1: "Proteção patrimonial completa e gestão de riscos personalizada para empresas e produtores rurais.",
        description2: "Garantimos a continuidade do seu negócio através de coberturas que protegem desde ativos físicos até a vida dos colaboradores.",
        cards: [
            // Mantendo o padrão de ícones: /assets/images/servicos/3/1.png
           { 
        icon: "/assets/images/servicos/3/1.png", 
        title: "Seguro Empresarial & Patrimonial", 
        disc: "Proteção completa para o seu negócio: cobertura contra incêndio, danos materiais, lucros cessantes, responsabilidade civil e segurança para condomínios comerciais." 
    },
    { 
        icon: "/assets/images/servicos/3/1.png", 
        title: "Seguro Rural", 
        disc: "Segurança do plantio à colheita. Soluções em penhor rural, proteção para máquinas agrícolas, benfeitorias, florestas e seguro de crédito rural." 
    },
    { 
        icon: "/assets/images/servicos/3/1.png", 
        title: "Gestão de Frotas & Veículos", 
        disc: "Proteção sob medida para frotas empresariais, caminhões, máquinas pesadas e seguro de Responsabilidade Civil Facultativa (RCFV)." 
    },
    { 
        icon: "/assets/images/servicos/3/1.png", 
        title: "Pessoas & Benefícios Corporativos", 
        disc: "Valorize sua equipe com seguros de vida em grupo, acidentes pessoais coletivos, planos de saúde empresarial e seguro viagem corporativo." 
    },
    { 
        icon: "/assets/images/servicos/3/1.png", 
        title: "Engenharia & Riscos Operacionais", 
        disc: "Garantia de ponta a ponta para obras civis, instalação, montagem e proteção completa contra riscos de engenharia." 
    },
    { 
        icon: "/assets/images/servicos/3/1.png", 
        title: "Consultoria & Gestão de Riscos", 
        disc: "Análise estratégica personalizada para identificar vulnerabilidades, mitigar ameaças e minimizar prejuízos financeiros na sua operação." 
    }
        ],
        processSteps: [
            { title: "Inventário", disc: "Mapeamento de todos os ativos e riscos do negócio." },
            { title: "Cotação", disc: "Busca pelas melhores taxas nas principais seguradoras." },
            { title: "Proteção", disc: "Implementação da apólice e suporte em sinistros." }
        ],
        benefitTitle: "Soluções em Proteção",
        benefitDisc: "Cuidamos do seu patrimônio com foco em:",
        benefits: [
            "Seguro Patrimonial Robusto",
            "Proteção de equipamentos agrícolas",
            "Gestão de seguros de vida e saúde",
            "Suporte técnico em regulação de sinistros"
        ]
    };

    return <ServiceDetailTemplate {...data} />;
}

export default Seguros;